var Ad = require('./src/core/Ad');

if (!window.console) {
	var c = {};

	c.log = function() {};

	c.error = function() {};

	window.console = c;
}

function Pushdown(config) {

	config.crea = this;
	this.ad = new Ad(config);
}

module.exports = Pushdown;
